import { render } from "./BoardTitle.vue?vue&type=template&id=46cb5dc9&ts=true"
import script from "./BoardTitle.vue?vue&type=script&lang=ts"
export * from "./BoardTitle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__